import { ComparisonModes } from '@/entities/market-intel/model/types';
import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetFlagsPerPersonRequestDtoSchema = z.object({
  facilityId: z.number(),
  comparisonSet: z.enum(ComparisonModes),
  from: z.string(),
  to: z.string(),
});

const GetFlagsPerPersonResponseDtoSchema = z.object({
  currentValue: z.number().nullable(),
  hint: z.string(),
  marketMedian: z.number().nullable(),
  message: z.string(),
});

export type GetFlagsPerPersonRequestDto = z.infer<
  typeof _GetFlagsPerPersonRequestDtoSchema
>;
export type GetFlagsPerPersonResponseDto = z.infer<
  typeof GetFlagsPerPersonResponseDtoSchema
>;

export const getFlagsPerPerson = (
  params: GetFlagsPerPersonRequestDto,
  config?: AxiosRequestConfig<GetFlagsPerPersonRequestDto>
) => {
  const { facilityId, ...queryParams } = params;

  return api
    .get(`/market-intelligence/facilities/${facilityId}/flags-per-person`, {
      params: queryParams,
      ...config,
    })
    .then(responseContract(GetFlagsPerPersonResponseDtoSchema));
};
